import { setupWorker } from 'msw/browser';
import { accountsHandlers } from './handlers/accounts';
import { rolesHandlers } from './handlers/roles';
import { approvalWorkflowHandlers } from './handlers/approval-workflow';
import { transactionsHandlers } from './handlers/transactions';
import { viewsHandlers } from './handlers/views';

export const worker = setupWorker(
  ...accountsHandlers,
  ...rolesHandlers,
  ...approvalWorkflowHandlers,
  ...transactionsHandlers,
  ...viewsHandlers
);
